<template>
    <a
        :key="item.id"
        :href="item.isExternal ? item.externalUrl : item.url"
        :title="item.name"
        class="flex p-5 lg:p-10 items-center bg-surface-green-30 gap-4 group"
    >
        <img :src="item.bildeIkkeValgt" class="w-[60px] h-[60px] "/>
        <p class="block text-xl w-full group-hover:underline line-clamp lines-2">
            {{ item.name }}
        </p>
        <div class="pl-0 pr-2 group-hover:pr-0 group-hover:pl-2 transition-all">
            <font-awesome-icon icon="arrow-right" class="py-2.5 w-7 h-5"/>
        </div>
    </a>
</template>

<script>
export default {
    props: ['item'],
};
</script>
